import {useQuery} from '@tanstack/react-query'
import {useMemo} from 'react'
import {EntitlementsService} from 'services/api'

interface UseEntitlementsOptions {
  enabled?: boolean
}

export const ENTITLEMENTS_QUERY_KEY = 'getEntitlements'

const defaultEntitlements = {
  swgDlpBlock: false,
  swgDlpEarlyAccess: false,
}

export const useEntitlementsQuery = ({
  enabled = false,
}: UseEntitlementsOptions = {}) => {
  const {data, isLoading, isFetching, isSuccess, refetch} = useQuery({
    queryKey: [ENTITLEMENTS_QUERY_KEY],
    queryFn: () => EntitlementsService.getEntitlements(),
    enabled,
  })

  const entitlementsData = useMemo(
    () => ({...defaultEntitlements, ...data}),
    [data],
  )

  return {
    ...entitlementsData,
    isLoading,
    isFetching,
    isSuccess,
    refetch,
  }
}
